import {
  FeatureImpl,
  IFeatureRepository,
} from "api/merchantRepository/features/FeatureRepository";
import {
  FilterFeatureImpl,
  IFilterFeatureRepository,
} from "api/merchantRepository/filterFeature/FilterFeatureRepository";
import {
  INotificationRepository,
  NotificationImpl,
} from "api/merchantRepository/notification/NotificationRepository";
import {
  ISupportFeatureRepository,
  SupportFeatureImpl,
} from "api/merchantRepository/supportFeature/SupportFeatureRepository";
import {
  AppTransactionImpl,
  IAppTransactionRepository,
} from "api/repositories/appTransaction/AppTransactionRepository";
import {
  CarrierImpl,
  ICarrierRepository,
} from "api/repositories/carrier/CarrierRepository";
import {
  CategoryRepositoryImpl,
  ICategoryRepository,
} from "api/repositories/category/CategoryRespository";
import {
  ITopupManagementRepository,
  TopupManagementImpl,
} from "api/repositories/packagesManagement/topupManagement/TopupManagementRepository";
import {
  IPartnerManagementRepository,
  PartnerManagementImpl,
} from "api/repositories/partnerManagement/PartnerManagementRepository";
import {
  IRoamingPartnerRepository,
  RoamingPartnerImpl,
} from "api/repositories/roamingPartnerManagement/RoamingPartnerRepository";
import {
  IRoleRepository,
  RoleRepositoryImpl,
} from "api/repositories/rolesList/RolesListRepository";
import { ActionInjection } from "app/actions/di/ActionInjection";
import { FilterInjection } from "app/filters/di/FilterInjection";
import { AppStartUpInjection } from "app/startup/di/AppStartUpInjection";
import { NotificationViewModel } from "components/header/notification/viewModel/NotificationViewModel";
import { SidebarMenuInjection } from "components/sidebar/di/SidebarMenuInjection";
import { ActionLogInjection } from "features/actionLogManagement/di/ActionLogInjection";
import { AirtimeManagementInjection } from "features/airTimeManagement/di/AirtimeManagementInjection";
import { AirTimeRegistrationInjection } from "features/airTimeRegistration/di/AirTimeRegistrationInjection";
import { ApiDocumentInjection } from "features/apiDocumentFeature/di/ApiDocumentInjection";
import { AppFeedbackInjection } from "features/appFeedback/di/AppFeedbackInjection";
import { AppProfileInjection } from "features/appProfileRegister/di/AppProfieInjection";
import { B2CUserInjection } from "features/b2cUserManagement/di/B2CUserInjection";
import { BalanceHistoryInjection } from "features/balanceHistory/di/BalanceHistoryInjection";
import { BussinessAppUserInjection } from "features/businessAppUserManagement/di/BussinessAppUserInjection";
import { CapabilityInjection } from "features/capabilityManagement/di/CapabilityInjection";
import { CashFlowInjection } from "features/cashFlow/di/CashFlowInjection";
import { CdnConfigInjection } from "features/cdnConfiguration/di/CdnConfigInjection";
import { ChangePasswordInjection } from "features/changePassword/di/ChangePasswordInjection";
import { CountryConfigInjection } from "features/countryConfiguration/di/CountryConfigInjection";
import { DiscountManagementInjection } from "features/discountManagement/di/DiscountManagementInjection";
import { ErrorCodeGeneralInjection } from "features/errorCodeGeneralFeature/di/ErrorCodeGeneralInjection";
import { ErrorCodeManagementInjection } from "features/errorCodeManagement/di/ErrorCodeManagementInjection";
import { GeneralsInjection } from "features/generals/di/GeneralsInjection";
import { IndividualUserInjection } from "features/individualUsersManagement/di/IndividualUserInjection";
import { IOTSimListLookupInjection } from "features/iotSimListLookup/di/IOTSimListLookupInjection";
import { AuthenticationInjection } from "features/login/di/AuthenticationInjection";
import { MobiSimRegistrationInjection } from "features/mobiSimRegistration/di/MobiSimRegistrationInjection";
import { NiceSimRegistrationInjection } from "features/niceSimRegistration/di/NiceSimRegistrationInjection";
import { OfficialDispatchInjection } from "features/officialDispatch/di/OfficialDispatchInjection";
import { PackageLookupInjection } from "features/packageLookup/di/PackageLookupInjection";
import { B2BPackageManagementInjection } from "features/packageManagement/b2bPackageManagement/di/B2BPackageManagementInjection";
import { PackageManagementViewModel } from "features/packageManagement/viewModel/PackageManagementViewModel";
import { PackageRegistrationInjection } from "features/packageRegistration/di/PackageRegistrationInjection";
import { PartnerManagementInjection } from "features/partnerManagement/di/PartnerManagementInjection";
import { PermissionDataInjection } from "features/permissionDataManagement/di/PermissionDataInjection";
import { RoleManagementInjection } from "features/roleManagement/di/RoleManagementInjection";
import { SimLookupInjection } from "features/simStatusLookup/di/SimLookupInjection";
import { StoreInjection } from "features/storeManagement/di/StoreInjection";
import { SupplierManagementInjection } from "features/supplierManagement/di/SupplierManagmentInjection";
import { SystemUserInjection } from "features/systemUserManagement/di/SystemUserInjection";
import { TravelSimRegistrationInjection } from "features/travelSimRegistration/di/TravelSimRegistrationInjection";
import { UserPermissionInjection } from "features/userPermissionManagement/di/UserPermissionInjection";
import { VnskySupportAlertInjection } from "features/vnskySupportAlert/di/VnskySupportAlertInjection";
import { VnskySupportOcsInfoInjection } from "features/vnskySupportOcsInfo/di/VnskySupportOcsInfoInjection";
import { container } from "tsyringe";
import { constructor } from "tsyringe/dist/typings/types";
import { InjectionToken } from "utils/injectionToken/InjectionToken";

export class DependenciesInjection {
  static alreadyInjected: boolean = false;
  static registeredToken: Array<string | symbol> = [];
  static resolvedToken: Map<string | symbol, any> = new Map();

  static register<T>(
    token: string | symbol,
    implClass: constructor<T>,
    type: "viewModel" | "otherRepo",
  ) {
    if (!container.isRegistered(token)) {
      container.register<T>(token, { useClass: implClass });
      if (type === "otherRepo") {
        this.registeredToken.push(token);
      }
    }
  }

  private static injectFeature() {
    this.register<IFeatureRepository>(
      InjectionToken.IFeatureRepository,
      FeatureImpl,
      "otherRepo",
    );
    FilterInjection.initInjections();
    ActionInjection.initInjections();
    AppStartUpInjection.initInjections();
    SidebarMenuInjection.initInjections();
  }

  private static injectDashboard() {
    GeneralsInjection.initInjections();
  }

  private static injectErrorCodeReport() {
    ErrorCodeGeneralInjection.initInjection();
  }

  private static injectErrorCodeManagement() {
    ErrorCodeManagementInjection.initInjection();
  }

  private static injectUserManagement() {
    BussinessAppUserInjection.initInjection();
    B2CUserInjection.initInjection();
    IndividualUserInjection.initInjections();
    SystemUserInjection.initInjections();
  }

  private static injectPackageRegistration() {
    this.register<IAppTransactionRepository>(
      InjectionToken.IAppTransactionRepository,
      AppTransactionImpl,
      "otherRepo",
    );
    PackageRegistrationInjection.initInjections();
  }

  private static injectNiceSimRegistration() {
    NiceSimRegistrationInjection.initInjections();
  }

  private static injectMobiSimRegistration() {
    MobiSimRegistrationInjection.initInjections();
  }

  private static injectTravelSimRegistration() {
    TravelSimRegistrationInjection.initInjections();
  }

  private static injectAirTimeRegistration() {
    AirTimeRegistrationInjection.initInjections();
  }

  private static injectCarrier() {
    this.register<ICarrierRepository>(
      InjectionToken.ICarrierRepository,
      CarrierImpl,
      "otherRepo",
    );
  }

  private static injectSupportFeature() {
    this.register<ISupportFeatureRepository>(
      InjectionToken.ISupportFeatureRepository,
      SupportFeatureImpl,
      "otherRepo",
    );
    this.register<INotificationRepository>(
      InjectionToken.INotificationRepository,
      NotificationImpl,
      "otherRepo",
    );
  }

  private static injectNoti() {
    this.register<INotificationRepository>(
      InjectionToken.INotificationRepository,
      NotificationImpl,
      "otherRepo",
    );
    this.register<NotificationViewModel>(
      InjectionToken.NotificationViewModel,
      NotificationViewModel,
      "viewModel",
    );
  }

  private static injectCategoryManagement() {
    this.register<ICategoryRepository>(
      InjectionToken.ICategoryRepository,
      CategoryRepositoryImpl,
      "otherRepo",
    );
  }

  private static injectFilterFeature() {
    this.register<IFilterFeatureRepository>(
      InjectionToken.IFilterFeatureRepository,
      FilterFeatureImpl,
      "otherRepo",
    );
  }

  private static injectCashFlow() {
    CashFlowInjection.initInjection();
  }

  private static injectCapabilityManagement() {
    CapabilityInjection.initInjections();
  }

  private static injectPackageManagement() {
    this.register<ITopupManagementRepository>(
      InjectionToken.ITopupManagementRepository,
      TopupManagementImpl,
      "otherRepo",
    );
    B2BPackageManagementInjection.injectB2BPackageManagement();
    this.register<PackageManagementViewModel>(
      InjectionToken.PackageManagementViewModel,
      PackageManagementViewModel,
      "viewModel",
    );
  }

  private static injectRoamingPartner() {
    this.register<IRoamingPartnerRepository>(
      InjectionToken.IRoamingPartnerRepository,
      RoamingPartnerImpl,
      "otherRepo",
    );
  }

  private static injectPartnerManagement() {
    this.register<IPartnerManagementRepository>(
      InjectionToken.IPartnerManagementRepository,
      PartnerManagementImpl,
      "otherRepo",
    );
    PartnerManagementInjection.initInjections();
  }

  private static injectDiscountFeature() {
    DiscountManagementInjection.initInjection();
  }

  private static injectAppProfileRegister() {
    AppProfileInjection.initInjection();
  }

  private static injectAppFeedbackFeature() {
    AppFeedbackInjection.initInjection();
  }

  private static injectStoreManagementFeature() {
    StoreInjection.initInjections();
  }

  private static injectChangePasswordFeature() {
    ChangePasswordInjection.initInjections();
  }

  private static injectRoleFeature() {
    this.register<IRoleRepository>(
      InjectionToken.IRoleRepository,
      RoleRepositoryImpl,
      "otherRepo",
    );
  }

  private static injectSupplierManagement() {
    SupplierManagementInjection.initInjections();
  }

  private static injectCountryConfig() {
    CountryConfigInjection.initInjection();
  }

  private static injectCdnConfigManagement() {
    CdnConfigInjection.initInjection();
  }

  private static injectPermissionDataManagement() {
    PermissionDataInjection.initInjections();
  }

  private static injectUserPermission() {
    UserPermissionInjection.initInjections();
  }

  private static injectRoleManagment() {
    RoleManagementInjection.initInjections();
  }

  private static injectSupport() {
    SimLookupInjection.initInjections();
    PackageLookupInjection.initInjections();
    ApiDocumentInjection.initInjections();
    OfficialDispatchInjection.initInjections();
  }

  private static injectIoTSIMSupport() {
    VnskySupportOcsInfoInjection.initInjections();
    VnskySupportAlertInjection.initInjections();
    IOTSimListLookupInjection.initInjections();
  }

  private static injectActionLog() {
    ActionLogInjection.initInjections();
  }

  private static registerAllTokens() {
    this.injectCategoryManagement();
    this.injectFeature();
    this.injectDashboard();
    this.injectErrorCodeReport();
    this.injectUserManagement();
    this.injectAirTimeRegistration();
    this.injectPackageRegistration();
    this.injectNiceSimRegistration();
    this.injectMobiSimRegistration();
    this.injectTravelSimRegistration();
    this.injectSupportFeature();
    this.injectCarrier();
    this.injectFilterFeature();
    this.injectCashFlow();
    this.injectCapabilityManagement();
    this.injectNoti();
    this.injectPackageManagement();
    this.injectRoamingPartner();
    this.injectPartnerManagement();
    this.injectDiscountFeature();
    this.injectAppProfileRegister();
    this.injectAppFeedbackFeature();
    this.injectErrorCodeManagement();
    this.injectStoreManagementFeature();
    this.injectChangePasswordFeature();
    this.injectRoleFeature();
    this.injectSupplierManagement();
    this.injectCdnConfigManagement();
    this.injectCountryConfig();
    this.injectPermissionDataManagement();
    this.injectUserPermission();
    this.injectRoleManagment();
    this.injectIoTSIMSupport();
    this.injectActionLog();
    this.injectSupport();
    AuthenticationInjection.injectAuthentication();
    AirtimeManagementInjection.injectAirtimeManagement();
    BalanceHistoryInjection.injectBalanceHistory();
  }

  private static checkInjectionAndResolve() {
    this.registeredToken.forEach((token) => {
      if (!container.isRegistered(token)) {
        throw new Error(`Unregistered token: ${String(token.toString())}`);
      }

      const dependency = container.resolve(token);
      this.resolvedToken.set(token, dependency);
    });
  }

  static lateResolution<T>(token: string | symbol): T {
    if (!token) {
      throw new Error("lateResolution: token is undefined");
    }
    if (!container.isRegistered(token)) {
      throw new Error(`Unregistered token: ${String(token)}`);
    }
    const singleDependency = container.resolve(token);
    return singleDependency as unknown as T;
  }

  static async initInjections() {
    if (this.alreadyInjected) return;
    this.registerAllTokens();
    this.checkInjectionAndResolve();
  }

  static getRepo<T>(token: string | symbol): T {
    const dependency = this.resolvedToken.get(token);
    if (!dependency) {
      throw new Error(`Token ${String(token)} not found`);
    }
    return dependency;
  }
}
